import Vue from "vue";

import AccountLogout from "@Account/Scripts/Components/Account/AccountLogout.vue";
import AccountUserInfo from "@Account/Scripts/Components/Account/AccountUserInfo.vue";
import AccountEdit from "@Scripts/Components/MyBeghelli/Profile/AccountEdit.vue";
import AccountProfileEdit from "@Scripts/Components/MyBeghelli/Profile/AccountProfileEdit.vue";
import AccountNotificationPreferences from "@Scripts/Components/MyBeghelli/Profile/AccountNotificationPreferences.vue";

import Pagination from "@Scripts/Components/Pagination/Pagination.vue";

import NewsletterSubscribe from "@Scripts/Components/Newsletter/NewsletterSubscribe.vue";
import NewsletterUnsubscribe from "@Scripts/Components/Newsletter/NewsletterUnsubscribe.vue";
import NewsletterToast from "@Scripts/Components/Newsletter/NewsletterToast.vue";

import CookieToast from "@Scripts/Components/CookieToast/CookieToast.vue";

import Feedback from "@Scripts/Components/Feedback/Feedback.vue";

import CatalogueFilterBox from "@Scripts/Components/Catalogue/CatalogueFilterBox.vue";
import CatalogueFamilyList from "@Scripts/Components/Catalogue/CatalogueFamilyList.vue";
import CatalogueProductList from "@Scripts/Components/Catalogue/CatalogueProductList.vue";
import CatalogueProductItem from "@Scripts/Components/Catalogue/CatalogueProductItem.vue";
import CatalogueProductDetail from "@Scripts/Components/Catalogue/ProductDetail/CatalogueProductDetail.vue";
import CatalogueProductDetailInformation from "@Scripts/Components/Catalogue/ProductDetail/CatalogueProductDetailInformation.vue";
import CatalogueProductDetailConfiguration from "@Scripts/Components/Catalogue/ProductDetail/CatalogueProductDetailConfiguration.vue";
import CatalogueProductDetailAccessories from "@Scripts/Components/Catalogue/ProductDetail/CatalogueProductDetailAccessories.vue";
import CatalogueProductDetailDocumentation from "@Scripts/Components/Catalogue/ProductDetail/CatalogueProductDetailDocumentation.vue";

import CatalogueMultipleValueListFilter from "@Scripts/Components/Catalogue/Filters/MultipleValueListFilter.vue";
import CatalogueRangeFilter from "@Scripts/Components/Catalogue/Filters/RangeFilter.vue";
import CatalogueSingleValueListFilter from "@Scripts/Components/Catalogue/Filters/SingleValueListFilter.vue";

import CatalogueHighlightFilter from "@Scripts/Components/CatalogueHighlight/CatalogueHighlightFilter.vue";

import ProductCard from "@Scripts/Components/ProductCard/ProductCard.vue";

import LanguageSelector from "@Scripts/Components/LanguageSelector/LanguageSelector.vue";
import LanguageSelectorButton from "@Scripts/Components/LanguageSelector/LanguageSelectorButton.vue";

import SkeletonLoader from "@Scripts/Components/SkeletonLoader/SkeletonLoader.vue";

import SupportRequest from "@Scripts/Components/SupportRequest/SupportRequest.vue";
import SupportSearchBox from "@Scripts/Components/SearchSupport/SupportSearchBox.vue";

import SearchBox from "@Scripts/Components/Search/SearchBox.vue";

import PageDetailFilter from "@Scripts/Components/PageDetail/PageDetailFilter.vue";

import Locator from "@Scripts/Components/Locator/Locator.vue";

import ProfileProductFavorite from "@Scripts/Components/ProfileProductFavorite/ProfileProductFavorite.vue";
import ProfileProductFavoriteRemove from "@Scripts/Components/ProfileProductFavorite/ProfileProductFavoriteRemove.vue";

import MyWidgetProduct from "@Scripts/Components/MyBeghelli/Dashboard/MyWidgetProduct.vue";
import MyWidgetOrder from "@Scripts/Components/MyBeghelli/Dashboard/MyWidgetOrder.vue";
import MyDocumentFilter from "@Scripts/Components/MyBeghelli/Document/MyDocumentFilter.vue";
import ShippingAddressList from "@Scripts/Components/MyBeghelli/ShippingAddress/ShippingAddressList.vue";
import ShippingAddressEdit from "@Scripts/Components/MyBeghelli/ShippingAddress/ShippingAddressEdit.vue";

import ProductDetailAdd from "@Scripts/Components/Store/Product/ProductDetailAdd.vue";
import CartDetail from "@Scripts/Components/Store/Cart/CartDetail.vue";
import CartPreview from "@Scripts/Components/Store/Cart/CartPreview.vue";

import CheckoutSummary from "@Scripts/Components/Store/Checkout/CheckoutSummary.vue";
import CheckoutConfirm from "@Scripts/Components/Store/Checkout/CheckoutConfirm.vue";

import ToastHub from "@Scripts/Components/Toast/ToastHub.vue";

import ExpMenu from "@Scripts/Directives/ExpMenu/ExpMenu";
import Tooltip from "@Scripts/Directives/Tooltip/Tooltip";

export default class AppConfig {
    public static AddComponents() {
        Vue.component("app-accountlogout", AccountLogout);
        Vue.component("app-accountuserinfo", AccountUserInfo);
        Vue.component("app-accountedit", AccountEdit);
        Vue.component("app-accountprofileedit", AccountProfileEdit);
        Vue.component("app-accountnotificationpreferences", AccountNotificationPreferences);

        Vue.component("app-pagination", Pagination);

        Vue.component("app-newsletter-subscribe", NewsletterSubscribe);
        Vue.component("app-newsletter-unsubscribe", NewsletterUnsubscribe);
        Vue.component("app-newslettertoast", NewsletterToast);

        Vue.component("app-cookietoast", CookieToast);

        Vue.component("app-feedback", Feedback);

        Vue.component("app-catalogue-filterbox", CatalogueFilterBox);
        Vue.component("app-catalogue-familylist", CatalogueFamilyList);
        Vue.component("app-catalogue-productlist", CatalogueProductList);
        Vue.component("app-catalogue-productitem", CatalogueProductItem);
        Vue.component("app-catalogue-productdetail", CatalogueProductDetail);
        Vue.component("app-catalogue-productdetail-information", CatalogueProductDetailInformation);
        Vue.component("app-catalogue-productdetail-configuration", CatalogueProductDetailConfiguration);
        Vue.component("app-catalogue-productdetail-accessories", CatalogueProductDetailAccessories);
        Vue.component("app-catalogue-productdetail-documentation", CatalogueProductDetailDocumentation);

        Vue.component("app-catalogue-multiplevaluelistfilter", CatalogueMultipleValueListFilter);
        Vue.component("app-catalogue-rangefilter", CatalogueRangeFilter);
        Vue.component("app-catalogue-singlevaluelistfilter", CatalogueSingleValueListFilter);

        Vue.component("app-productcard", ProductCard);

        Vue.component("app-catalogue-highlight-filter", CatalogueHighlightFilter);

        Vue.component("app-languageselector", LanguageSelector);
        Vue.component("app-languageselectorbutton", LanguageSelectorButton);

        Vue.component("app-skeletonloader", SkeletonLoader);

        Vue.component("app-searchbox", SearchBox);

        Vue.component("app-pagedetailfilter", PageDetailFilter);

        Vue.component("app-supportrequest", SupportRequest);
        Vue.component("app-supportsearchbox", SupportSearchBox);

        Vue.component("app-locator", Locator);

        Vue.component("app-profileproductfavorite", ProfileProductFavorite);
        Vue.component("app-profileproductfavoriteremove", ProfileProductFavoriteRemove);

        Vue.component("app-mywidgetproduct", MyWidgetProduct);
        Vue.component("app-mywidgetorder", MyWidgetOrder);
        Vue.component("app-mydocumentfilter", MyDocumentFilter);
        Vue.component("app-shippingaddresslist", ShippingAddressList);
        Vue.component("app-shippingaddressedit", ShippingAddressEdit);

        Vue.component("app-productdetailadd", ProductDetailAdd);
        Vue.component("app-cartdetail", CartDetail);
        Vue.component("app-cartpreview", CartPreview);

        Vue.component("app-checkoutsummary", CheckoutSummary);
        Vue.component("app-checkout-confirm", CheckoutConfirm);

        Vue.component("app-toasthub", ToastHub);
    }

    public static AddDirectives() {
        Vue.directive("exp-menu", ExpMenu);
        Vue.directive("tooltip", Tooltip);
    }
}